export default __webpack_public_path__ + "static/media/arrow_down_black.8bc646e8.svg";